import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { useNavigate } from 'Pods/Shared/ContextBasedRouter'
import useApiDelete from 'Pods/Shared/Hooks/useApiDelete'
// eslint-disable-next-line max-len
import { removeSessionFromLibraryCache } from 'Pods/ThreeDStudio/Components/Sidebar/Components/LibraryContent/Services/removeSessionFromLibraryCache'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { resetOpenedModelState } from 'Pods/ThreeDStudio/Store/actions/ui'

const showNotification = (message, type) => {
  if (typeof window !== 'undefined' && window.showNotification) {
    window.showNotification(message, { type, autohide: true })
  }
}

function useDeleteModelSession({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { deleteData, isLoading } = useApiDelete()

  const deleteModel = useCallback((sessionId) => {
    if (sessionId == null) return

    deleteData({
      path: `/api/internal/generator/sessions/${sessionId}`,
      onSuccess: () => {
        removeSessionFromLibraryCache(queryClient, { sessionId })

        const openedSessionId = threeDStudioStore.getState().ui?.openedModel?.generatorSessionId
        if (openedSessionId != null && String(openedSessionId) === String(sessionId)) {
          resetOpenedModelState()
          navigate('/ai', { replace: true })
        }

        showNotification('Model deleted successfully.', 'success')
        if (onSuccess) onSuccess()
      },
      onError: (error) => {
        showNotification('Failed to delete model. Please try again.', 'error')
        if (onError) onError(error)
      },
    })
  }, [deleteData, navigate, onError, onSuccess, queryClient])

  return { deleteModel, isLoading }
}

export default useDeleteModelSession
